import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getMySubscription } from "../../services/GameService";
import "./CheckoutResultPage.css";

const MAX_POLLS = 5;
const POLL_DELAY_MS = 1500;

// Checkout success return page. The subscription is activated asynchronously by
// the Stripe webhook, so poll a few times until it shows active.
const CheckoutSuccessPage = () => {
  const [active, setActive] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    let cancelled = false;
    let attempts = 0;

    const poll = async () => {
      try {
        const data = await getMySubscription();
        if (cancelled) return;
        if (data.has_active_subscription) {
          setActive(true);
          setDone(true);
          return;
        }
      } catch (e) {
        // ignore and retry
      }
      attempts += 1;
      if (attempts >= MAX_POLLS) {
        if (!cancelled) setDone(true);
        return;
      }
      setTimeout(poll, POLL_DELAY_MS);
    };

    poll();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="checkout-result">
      <h1 className="cr-title">Thank you!</h1>
      {active ? (
        <p className="cr-message">
          Your subscription is active — every game is unlocked. Enjoy!
        </p>
      ) : done ? (
        <p className="cr-message">
          Payment received. Your subscription is being set up and will be
          active shortly.
        </p>
      ) : (
        <p className="cr-message">Confirming your subscription…</p>
      )}
      <Link className="cr-btn" to="/home">
        Go to games
      </Link>
    </div>
  );
};

export default CheckoutSuccessPage;
